import {
  getTicketingWorkItemKind,
  type TicketingWorkItemKind,
} from '@terra/shared-contracts-integrations';
import {
  isLinkedTicketProvider,
  type LinkedTicketProvider,
} from '@terra/shared-contracts-findings';

type LinkedTicketTranslate = {
  (key: string): string;
  has: (key: string) => boolean;
};

type TicketingWorkItemTranslate = {
  (key: string): string;
};

export const resolveLinkedTicketProvider = ({
  ticketProvider,
  fallbackProvider,
}: {
  ticketProvider: string | undefined;
  fallbackProvider: LinkedTicketProvider | null;
}): LinkedTicketProvider | null => {
  if (ticketProvider && isLinkedTicketProvider(ticketProvider)) {
    return ticketProvider;
  }

  return fallbackProvider;
};

export const translateLinkedTicketOverview = ({
  t,
  provider,
  key,
}: {
  t: LinkedTicketTranslate;
  provider: LinkedTicketProvider | null;
  key: string;
}): string => {
  if (provider) {
    const providerKey = `linkedTicketCopy.${provider}.${key}`;

    if (t.has(providerKey)) {
      return t(providerKey);
    }
  }

  return t(key);
};

export const translateTicketingWorkItem = ({
  t,
  kind,
}: {
  t: TicketingWorkItemTranslate;
  kind: TicketingWorkItemKind;
}): string => t(`audit.workItem.${kind}`);

export const getLinkedTicketWorkItemKind = ({
  provider,
}: {
  provider: string | null | undefined;
}): TicketingWorkItemKind => {
  if (provider && isLinkedTicketProvider(provider)) {
    return getTicketingWorkItemKind({ provider });
  }

  return 'issue';
};
